import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import UserListing from './UsersListingPage/UserListing'
import UserDetails from './UserdetailsPage/UserDetails'
import MenuContainer from '../../Components/MenuContainer/MenuContainer'
import MainContainer from '../../Components/MainContainer/MainContainer'
import HeaderSection from '../../Components/HeaderSection'
import SideBar from '../../Components/SideBarComponent/SideBar'
import Menulist from './MenuList/Menulist'
import AccountList from './AcountList/AccountList'
import HitDashboard from '../../pixlhitScreens/HitDashboard'
import Client from '../../pixlhitScreens/Client/Client'
import Services from '../../pixlhitScreens/Services/Services'
import ServicesKey from '../../pixlhitScreens/Services/ServicesKey'
import DeploymentServer from '../../pixlhitScreens/DeploymentServer/DeploymentServer'
import HitOverview from '../../pixlhitScreens/Hit/HitOverview'
import ClientListing from './ClientListingPage/ClientListing'
import ClientDetails from './ClietnDetailsPage/ClientDetails'
import ApiHits from '../Apihits/ApiHits'
import ClientAdminList from './ClientAdminListPage/ClientAdminList'
import ServiceLogs from '../ServiceLogs/ServiceLogs'
import HeadlessAppHitLogs from '../HeadlessAppHitLogs/HeadlessAppHitLogs'

export default function AdminScreen() {

  const { pathname } = useLocation()
  useEffect(() => {
    // //console.log(pathname)
  }, [pathname])
  const renderAdminPages = () => {
    switch (pathname) {
      case "/admin/user_list":
        return (<UserListing />)
        break;
      case "/admin/user-details":
        return (<UserDetails />)
        break;
      case "/admin/acount_list":
        return (<AccountList />)
        break;
      case "/admin/menu_list":
        return (<Menulist />)
        break;
      case "/admin/hit-dashboard":
        return (<HitDashboard />)
        break;
      case "/admin/hit-client":
        return (<Client />)
        break;
      case "/admin/hit-services":
        return (<Services />)
        break;
      case "/admin/hit-key":
        return (<ServicesKey />)
        break;
      case "/admin/hit-deploymentserver":
        return (<DeploymentServer />)
        break;
      case "/admin/hit-hitoverview":
        return (<HitOverview />)
        break;
      case "/admin/clientlist":
        return (<ClientListing />)
        break;
      case "/admin/clientdetails":
        return (<ClientDetails />)
        break;
      case "/api-logs":
        return (<ApiHits />)
      case "/service-logs":
        return (<ServiceLogs />)
        break;
      case "/headless-app-hit-logs":
        return (<HeadlessAppHitLogs />)
        break;
      case "/admin/client_admin_list":
        return (<ClientAdminList/>)
        break;

      default:
        break;
    }
  }
  return (

    <>
      {renderAdminPages()}
    </>


  )
}
